/* eslint-disable */

import { initialValues } from "src/helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle";
import AddMoreButton from "../AddMoreButton";
import CustomCheckBox from "../CustomCheckBox";
// import CustomRadioButton from "../CustomRadioButton";
import CustomReviewField from "../CustomReviewField";
// import CustomSelect from "../CustomSelect";
import CustomizedSwitches from "../CustomToggleButton";
import FamilyMedicalHistoryMembersForm from "./FamilyMedicalHistory";
import MedicalSelectBox from "./MedicalSelextBox";
import MedicalTextBox from "./MedicalTextBox";
import JFSMedicalQuestions from "./JFSMedicalQuestions";

interface Props {
  formValues: any;
  setFieldValue?: any;
  handleBlurs?: any;
  isReview: boolean;
  label: string;
  handleChanges?: any;
  error: any;
  touch: any;
  setFieldTouch?: any;
  jointMarginRequired?: boolean;
  fieldObj?: any;
  gender?: string;
  width?: any;
  smokerError?: boolean;
  alcoholError?: boolean;
  frequencyError?: boolean;
  questions: Record<string, any>;
  displayAdditionalQue: boolean;
}

function MedicalAndLifestyle({
  formValues,
  gender,
  setFieldValue,
  handleBlurs,
  isReview,
  label,
  handleChanges,
  error,
  touch,
  setFieldTouch,
  jointMarginRequired,
  width,
  fieldObj,
  smokerError,
  alcoholError,
  frequencyError,
  questions = {},
  displayAdditionalQue
}: Props) {
  const handleAddingMoreSibling = (
    formValues: {
      medicalDetails: { familyMedicalHistory: any };
    },
    setFieldValue: (arg0: string, arg1: any) => void
  ) => {
    const newValue = [
      ...formValues.medicalDetails.familyMedicalHistory,
      initialValues.medicalDetails.familyMedicalHistory[0]
    ];
    setFieldValue("medicalDetails.familyMedicalHistory", newValue);
  };

  return (
    <div
      className={`container mx-auto bg-white text-sm font-montserrat normal font-medium leading-50 w-${width}`}
    >
      {questions?.declare && (
        <>
          <div className="flex xl:mt-7 lg:mt-7 md:mt-7 sm:mt-10.75 mt-10.75 ">
            <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-24 lg:h-auto md:h-auto sm:h-auto h-75 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4">
              {questions?.declare}
            </p>
            <div
              className={`flex flex-col ${
                label !== "Self" ? "xl:mr-2.5" : "xl:mr-10"
              } lg:mr-10 md:mr-10 sm:mr-10 mr-3`}
            >
              <p className=" text-base leading-6 font-semibold mb-5.75 ml-1 mt-1 xl:whitespace-nowrap">
                {label}
              </p>
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.declare}
                fieldName={"declare"}
                fieldObj={"medicalDetails"}
                setFieldValue={setFieldValue}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
        </>
      )}
      {displayAdditionalQue && (
        <>
          {questions?.extraQuestions?.hospitalisation && (
            <>
              <div className="flex xl:mt-7 lg:mt-7 md:mt-7 sm:mt-10.75 mt-10.75 ">
                <p
                  className={`xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-16 lg:h-auto md:h-auto sm:h-auto h-75 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4`}
                >
                  {questions?.extraQuestions?.hospitalisation}
                </p>
                <div
                  className={`flex flex-col ${
                    label !== "Self" ? "xl:mr-2.5" : "xl:mr-10"
                  } lg:mr-10 md:mr-10 sm:mr-10 mr-1`}
                >
                  <p className=" text-base leading-6 font-semibold mb-5.75 ml-1 mt-1 xl:whitespace-nowrap">
                    {label}
                  </p>
                  <CustomizedSwitches
                    isEnabled={!isReview ? true : false}
                    toggleState={formValues.medicalDetails.hospitalisation}
                    fieldName={"hospitalisation"}
                    fieldObj={"medicalDetails"}
                    setFieldValue={setFieldValue}
                  />
                </div>
              </div>
              <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
            </>
          )}
          {questions?.extraQuestions?.underTreatment && (
            <>
              <div className="flex xl:mt-7 lg:mt-7 md:mt-7 sm:mt-10.75 mt-10.75 ">
                <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-16 lg:h-auto md:h-auto sm:h-auto h-75 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4">
                  {questions?.extraQuestions?.underTreatment}
                </p>
                <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
                  <CustomizedSwitches
                    isEnabled={!isReview ? true : false}
                    toggleState={formValues.medicalDetails.underTreatment}
                    fieldName={"underTreatment"}
                    fieldObj={"medicalDetails"}
                    setFieldValue={setFieldValue}
                  />
                </div>
              </div>
              <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
            </>
          )}
          {questions?.extraQuestions?.majorDisorder && (
            <>
              <div className="flex xl:mt-7 lg:mt-7 md:mt-7 sm:mt-10.75 mt-10.75 ">
                <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-36 lg:h-auto md:h-auto sm:h-auto h-75 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4">
                  {questions?.extraQuestions?.majorDisorder}
                </p>
                <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
                  <CustomizedSwitches
                    isEnabled={!isReview ? true : false}
                    toggleState={formValues.medicalDetails.majorDisorder}
                    fieldName={"majorDisorder"}
                    fieldObj={"medicalDetails"}
                    setFieldValue={setFieldValue}
                  />
                </div>
              </div>
              <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
            </>
          )}
          {questions?.extraQuestions?.existingApplication && (
            <>
              <div className="flex xl:mt-7 lg:mt-7 md:mt-7 sm:mt-10.75 mt-10.75 ">
                <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-16 lg:h-auto md:h-auto sm:h-auto h-75 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4">
                  {questions?.extraQuestions?.existingApplication}
                </p>
                <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
                  <CustomizedSwitches
                    isEnabled={!isReview ? true : false}
                    toggleState={formValues.medicalDetails.existingApplication}
                    fieldName={"existingApplication"}
                    fieldObj={"medicalDetails"}
                    setFieldValue={setFieldValue}
                  />
                </div>
              </div>
              <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
            </>
          )}
          {questions?.extraQuestions?.familyHealth && (
            <>
              <div className="flex xl:mt-7 lg:mt-7 md:mt-7 sm:mt-10.75 mt-10.75 ">
                <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-16 lg:h-auto md:h-auto sm:h-auto h-75 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4">
                  {questions?.extraQuestions?.familyHealth}
                </p>
                <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
                  <CustomizedSwitches
                    isEnabled={!isReview ? true : false}
                    toggleState={formValues.medicalDetails.familyHealth}
                    fieldName={"familyHealth"}
                    fieldObj={"medicalDetails"}
                    setFieldValue={setFieldValue}
                  />
                </div>
              </div>
              <hr className=" border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
            </>
          )}
        </>
      )}
      {questions?.medicalHealth && (
        <>
          <div className="flex mt-5">
            <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-24 lg:h-auto md:h-auto sm:h-auto h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
              {questions?.medicalHealth}
            </p>
            <div
              className={`flex flex-col ${
                label !== "Self" && !displayAdditionalQue ? "xl:mr-2.5" : "xl:mr-10"
              } lg:mr-10 md:mr-10 sm:mr-10 mr-3`}
            >
              {!displayAdditionalQue && (
                <p className=" text-base leading-6 font-semibold mb-5.75 ml-1 mt-1 xl:whitespace-nowrap">
                  {label}
                </p>
              )}
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.medicalHealth}
                fieldName="medicalHealth"
                setFieldValue={setFieldValue}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          <hr className=" border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
        </>
      )}
      {!isReview && (
        <>
          <div className="flex xl:flex-row lg:flex-row md:flex-row sm:flex-row flex-col mt-6">
            {questions?.weight && (
              <div className="flex flex-row xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10  mr-4 lg:w-60 md:w-60 w-auto h-14">
                <MedicalTextBox
                  globalClassName={"rounded-l-lg"}
                  requiredStar
                  label={questions?.weight}
                  className="!w-full"
                  onChange={handleChanges}
                  handleBlur={handleBlurs}
                  value={formValues?.medicalDetails?.weight}
                  name={"medicalDetails.weight"}
                  error={error?.medicalDetails?.weight}
                  touched={touch?.medicalDetails?.weight}
                  disabledField={isReview}
                />
                <div>
                  <MedicalTextBox
                    globalClassName={"rounded-r-lg"}
                    className="!w-20"
                    label={questions?.measurement}
                    onChange={handleChanges}
                    name="Kgs"
                    disabledField={true}
                    value={"Kg"}
                    handleBlur={handleBlurs}
                  />
                </div>
              </div>
            )}
            {questions.height && formValues?.medicalDetails?.measurement === "cm" && (
              <div className="flex flex-row xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 h-14 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mr-4">
                <MedicalTextBox
                  globalClassName={"rounded-l-lg"}
                  requiredStar
                  label={questions?.height}
                  className="xl:w-38 lg:w-38 md:w-38 w-full xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                  onChange={handleChanges}
                  handleBlur={handleBlurs}
                  value={formValues?.medicalDetails?.height?.centimeter?.cm}
                  name={"medicalDetails.height.centimeter.cm"}
                  error={error?.medicalDetails?.height?.centimeter?.cm}
                  touched={touch?.medicalDetails?.height?.centimeter?.cm}
                  disabledField={isReview}
                />
                <MedicalSelectBox
                  className="!w-20 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                  label={questions?.measurement}
                  options={["cm", "Inch/Ft"]}
                  onChange={handleChanges}
                  setFieldTouched={setFieldTouch}
                  name="medicalDetails.measurement"
                  disabledField={isReview}
                  value={formValues?.medicalDetails?.measurement}
                />
              </div>
            )}
            {questions.height && formValues?.medicalDetails?.measurement !== "cm" && (
              <div className="flex flex-row">
                <div className="xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 h-14">
                  <MedicalTextBox
                    globalClassName={"rounded-l-lg"}
                    requiredStar
                    label="Feet"
                    className="xl:w-19.5 lg:w-19.5 md:w-19.5 w-full xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.height?.inchFeet?.feet}
                    name={"medicalDetails.height.inchFeet.feet"}
                    error={error?.medicalDetails?.height?.inchFeet?.feet}
                    touched={touch?.medicalDetails?.height?.inchFeet?.feet}
                    disabledField={isReview}
                  />
                  &ensp;
                </div>
                <div className=" h-14">
                  <MedicalTextBox
                    globalClassName={""}
                    requiredStar
                    label="Inches"
                    className="xl:w-19.5 lg:w-19.5 md:w-19.5 w-full xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.height?.inchFeet?.inches}
                    name={"medicalDetails.height.inchFeet.inches"}
                    error={error?.medicalDetails?.height?.inchFeet?.inches}
                    touched={touch?.medicalDetails?.height?.inchFeet?.inches}
                    disabledField={isReview}
                  />
                </div>
                <div className=" h-14">
                  <MedicalSelectBox
                    className="w-20 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5 mr-4 "
                    label={questions?.measurement}
                    options={["cm", "Inch/Ft"]}
                    onChange={handleChanges}
                    setFieldTouched={setFieldTouch}
                    name="medicalDetails.measurement"
                    disabledField={isReview}
                    value={formValues?.medicalDetails?.measurement}
                  />
                </div>
              </div>
            )}
          </div>
          <hr className="border-dashed border-t-2 mt-10 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}
      {isReview && (
        <>
          <div>
            <div className="flex items-center mt-6">
              {questions?.weight && (
                <h1 className="xl:ml-18 lg:ml-18 md:ml-18 sm:ml-18 ml-5 w-24">
                  {questions?.weight}*
                </h1>
              )}
              <div className="ml-20 xl:ml-42.25 lg:ml-33 md:ml-33 sm:ml-24 w-24">
                <h1>{questions?.height}*</h1>
              </div>
            </div>

            <div className="flex items-center mt-3">
              {questions?.weight && (
                <h1 className="xl:ml-18 lg:ml-18 md:ml-18 sm:ml-18 ml-5 w-24">
                  {" "}
                  {formValues?.medicalDetails?.weight ? (
                    <CustomReviewField>{formValues.medicalDetails.weight} Kgs </CustomReviewField>
                  ) : (
                    ""
                  )}
                </h1>
              )}
              {questions?.height && (
                <div className="ml-20 xl:ml-42.25 lg:ml-33 md:ml-33 sm:ml-24 w-24 whitespace-nowrap">
                  <h1>
                    {formValues?.medicalDetails?.height?.centimeter?.cm !== "" ? (
                      <CustomReviewField>
                        {formValues.medicalDetails?.height?.centimeter?.cm} Cm
                      </CustomReviewField>
                    ) : (
                      <CustomReviewField>
                        {formValues.medicalDetails?.height?.inchFeet?.feet} Feet &ensp;
                        {formValues.medicalDetails?.height?.inchFeet?.inches} Inches
                      </CustomReviewField>
                    )}
                  </h1>
                </div>
              )}
            </div>
          </div>
          <hr className="border-dashed border-t-2 mt-10 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}

      <JFSMedicalQuestions
        questions={questions}
        isReview={isReview}
        formValues={formValues}
        setFieldValue={setFieldValue}
        error={error}
        touch={touch}
        handleChanges={handleChanges}
        handleBlurs={handleBlurs}
        gender={gender!}
      />
      {questions?.sufferings?.heading && (
        <div className="flex items-center my-6">
          <p className="xl:w-202.5 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-0 mr-17.25 ">
            {questions?.sufferings?.heading}
          </p>
        </div>
      )}
      {questions?.sufferings?.diabetes && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.diabetes}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.diabetes}
              fieldName="diabetes"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.diabetesAndSugar && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.diabetesAndSugar}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.diabetesAndSugar}
              fieldName="diabetesAndSugar"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.highBloodPressure && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.highBloodPressure}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.highBloodPressure}
              fieldName="highBloodPressure"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.bloodPressureHeartAttack && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.bloodPressureHeartAttack}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.bloodPressureHeartAttack}
              fieldName="bloodPressureHeartAttack"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.stroke && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.stroke}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.stroke}
              fieldName="stroke"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.strokeParalysis && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.strokeParalysis}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.strokeParalysis}
              fieldName="strokeParalysis"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.asthma && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.asthma}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.asthma}
              fieldName="asthma"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.asthamaTuberculosis && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.asthamaTuberculosis}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.asthamaTuberculosis}
              fieldName="asthamaTuberculosis"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.indigestion && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.indigestion}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.indigestion}
              fieldName="indigestion"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.kidneyStoneBloodUrine && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.kidneyStoneBloodUrine}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.kidneyStoneBloodUrine}
              fieldName="kidneyStoneBloodUrine"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.anaemia && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.anaemia}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.anaemia}
              fieldName="anaemia"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.epilepsy && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.epilepsy}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.epilepsy}
              fieldName="epilepsy"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.liverDisease && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.liverDisease}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.liverDisease}
              fieldName="liverDisease"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.kidneyDisease && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.kidneyDisease}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.kidneyDisease}
              fieldName="kidneyDisease"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.bloodDisorder && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.bloodDisorder}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.bloodDisorder}
              fieldName="bloodDisorder"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.tumor && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.tumor}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.tumor}
              fieldName="tumor"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.cancerTumor && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.cancerTumor}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.cancerTumor}
              fieldName="cancerTumor"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.arthritis && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.arthritis}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.arthritis}
              fieldName="arthritis"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.anxiety && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.anxiety}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.anxiety}
              fieldName="anxiety"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.anxietyDepression && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-8 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.anxietyDepression}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.anxietyDepression}
              fieldName="anxietyDepression"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.thyroid && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.thyroid}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.thyroid}
              fieldName="thyroid"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.aids && (
        <div className="flex items-center mb-6">
          <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
            {questions?.sufferings?.aids}
          </p>

          <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
            <CustomizedSwitches
              isEnabled={!isReview ? true : false}
              toggleState={formValues.medicalDetails.aids}
              fieldName="aids"
              setFieldValue={setFieldValue}
              fieldObj={"medicalDetails"}
            />
          </div>
        </div>
      )}
      {questions?.sufferings?.otherDisease && (
        <>
          <div className="flex items-center mb-6">
            <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
              {questions?.sufferings?.otherDisease}
            </p>

            <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.otherDisease}
                fieldName="otherDisease"
                setFieldValue={setFieldValue}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          {formValues.medicalDetails.otherDisease && (
            <div className=" xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 mt-4 ">
              <MedicalTextBox
                label="Enter Details"
                className=""
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formValues?.medicalDetails?.otherDiseaseDetails}
                name={"medicalDetails.otherDiseaseDetails"}
                error={error?.medicalDetails?.otherDiseaseDetails}
                touched={touch?.medicalDetails?.otherDiseaseDetails}
                disabledField={isReview}
              />
            </div>
          )}
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
        </>
      )}
      {questions?.occupationEnquiry && (
        <>
          <div className="flex ">
            <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-20 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
              {questions?.occupationEnquiry}
            </p>

            <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.occupationEnquiry}
                fieldName="occupationEnquiry"
                setFieldValue={setFieldValue}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
        </>
      )}
      {questions?.familyMedicalHistory?.heading && (
        <>
          <div className="flex ">
            <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-24 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
              Have any of your natural parents, brothers or sisters died or suffered from diabetes,
              hypertension, heart disease, stroke or cancer below the age of 60 years? If 'Yes'
              please provide relation with such persons, age in years and present state of health
              (if living), age at death in years and cause of death (if deceased) in additional
              sheets.
            </p>

            <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.familyHealthHistory}
                fieldName="familyHealthHistory"
                setFieldValue={setFieldValue}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
        </>
      )}

      {formValues?.medicalDetails?.familyHealthHistory && (
        <div>
          {formValues.medicalDetails?.familyMedicalHistory?.map((_: any, index: number) => {
            return (
              <FamilyMedicalHistoryMembersForm
                formValues={formValues}
                handleChanges={handleChanges}
                handleBlurs={handleBlurs}
                error={error}
                touch={touch}
                isReview={isReview}
                setFieldTouch={setFieldTouch}
                setFieldValue={setFieldValue}
                index={index}
                questions={questions?.familyMedicalHistory}
                handleRemoveClick={(nomineeIndex: number) => {
                  const filteredData = formValues?.medicalDetails?.familyMedicalHistory.filter(
                    (_: any, index: number) => index !== nomineeIndex
                  );

                  setFieldValue("medicalDetails.familyMedicalHistory", filteredData);
                }}
              />
            );
          })}
          <div className="w-auto xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4">
            {!isReview && formValues.medicalDetails?.familyMedicalHistory?.length! < 6 && (
              <AddMoreButton
                label="Add More (Max.5)"
                onClick={() => handleAddingMoreSibling(formValues, setFieldValue)}
              />
            )}
          </div>

          {/* )} */}
          {/* 2 ka divider */}
          {/* <div className="flex justify-between mt-6 ">
            <div className="w-477/1000 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4">
              <p className="mb-4 text-daintree font-montserrat text-sm font-medium">
                Cause of Death of Deceased Person
              </p>
              <MedicalTextBox
                label="Enter"
                requiredStar
                className=""
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formValues?.medicalDetails?.causeDeath}
                name={"medicalDetails.causeDeath"}
                error={error?.medicalDetails?.causeDeath}
                touched={touch?.medicalDetails?.causeDeath}
                disabledField={isReview}
              />
            </div>

            <div className="w-477/1000 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4">
              <p className="mb-4 text-daintree font-montserrat text-sm font-medium">
                Age of Suffering Person (if living)
              </p>
              <MedicalTextBox
                label="Enter"
                requiredStar
                className=""
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formValues?.medicalDetails?.sufferingAge}
                name={"medicalDetails.sufferingAge"}
                error={error?.medicalDetails?.sufferingAge}
                touched={touch?.medicalDetails?.sufferingAge}
                disabledField={isReview}
              />
            </div>
            <div className="w-477/1000 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4">
              <p className=" text-daintree font-montserrat text-sm font-medium">
                Present state of health of Suffering Person (if living)
              </p>
              <MedicalTextBox
                label="Enter"
                requiredStar
                className=""
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formValues?.medicalDetails?.presentStateOfHealth}
                name={"medicalDetails.presentStateOfHealth"}
                error={error?.medicalDetails?.presentStateOfHealth}
                touched={touch?.medicalDetails?.presentStateOfHealth}
                disabledField={isReview}
              />
            </div>
          </div> */}
        </div>
      )}
      {questions?.smoker?.heading && (
        <>
          <div className="flex items-center">
            <p className=" xl:w-208.5 lg:w-208.5 md:w-208.5 sm:w-208.5 w-47 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-49 lg:mr-49 md:mr-49 sm:mr-49 mr-24.25 xl:whitespace-nowrap lg:whitespace-nowrap">
              {questions?.smoker?.heading}
            </p>

            <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 ">
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.smoker}
                fieldName="smoker"
                setFieldValue={setFieldValue}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}
      <div className="xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 whitespace-nowrap text-hotShot text-xs">
        {smokerError && <p>Atleast one value is required</p>}
      </div>

      {formValues.medicalDetails.smoker && (
        <>
          <div className="flex flex-row  xl:flex-col lg:flex-col xl:ml-0 lg:ml-0 md:ml-10  xl:mr-0 lg:mr-0 md:mr-10   ">
            <div className="flex xl:mt-8.75 lg:mt-8.75 md:mt-4 sm:mt-4 mt-4 xl:w-auto lg:w-auto md:w-64 sm:w-53.25 w-43.25 xl:ml-10 lg:ml-10    xl:mr-13.25 lg:mr-10  items-center flex-col xl:flex-row lg:flex-row order-first ">
              {questions?.smoker?.type && (
                <p className="flex xl:h-7.25 w-29.5 xl:mb-0 lg:mb-0 md:mb-6 sm:mb-7 mb-10 xl:whitespace-nowrap lg:whitespace-nowrap ">
                  {questions?.smoker?.type}*
                </p>
              )}

              {questions?.smoker?.cigaratte && (
                <div
                  className={
                    "flex lg:ml-9.75  xl:mb-0 lg:mb-0 md:mb-10 sm:mb-9 mb-9 " +
                    (jointMarginRequired ? "xl:ml-11.75" : "xl:ml-11.75")
                  }
                >
                  <div className="xl:h-7.25 xl:w-16.5 lg:w-16.5 md:w-35.25 sm:w-35.25 w-32 ">
                    <CustomCheckBox
                      label={questions?.smoker?.cigaratte}
                      name="medicalDetails.cigaratte"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.cigaratte}
                    />
                  </div>
                </div>
              )}

              {questions?.smoker?.bidi && (
                <div
                  className={
                    "flex lg:ml-18.5 xl:mb-0 lg:mb-0 md:mb-12 sm:mb-10 mb-10 " +
                    (jointMarginRequired ? "xl:ml-18.5" : "xl:ml-25.5")
                  }
                >
                  <div className="xl:h-7.25 xl:w-7 lg:w-7 md:w-35.25 sm:w-35.25 w-32">
                    <CustomCheckBox
                      label={questions?.smoker?.bidi}
                      name="medicalDetails.bidi"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.bidi}
                    />
                  </div>
                </div>
              )}

              {questions?.smoker?.cigar && (
                <div
                  className={
                    "flex lg:ml-28.5  xl:mb-0 lg:mb-0 md:mb-11 sm:mb-11 mb-11 " +
                    (jointMarginRequired ? "xl:ml-28.5" : "xl:ml-36.25 ")
                  }
                >
                  <div className="xl:h-7.25 xl:w-9.5 lg:w-9.5 md:w-35.25 sm:w-35.25 w-32">
                    <CustomCheckBox
                      label={questions?.smoker?.cigar}
                      name="medicalDetails.cigar"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.cigar}
                    />
                  </div>
                </div>
              )}

              {questions?.smoker?.panMasala && (
                <div
                  className={
                    "flex   xl:mb-0 lg:mb-0 md:mb-9 sm:mb-9 mb-9 " +
                    (jointMarginRequired ? "xl:ml-26.25 lg:ml-auto" : "xl:ml-26.25 lg:ml-26.25")
                  }
                >
                  <div className="xl:h-7.25 xl:w-20.25 lg:w-20.25 md:w-35.25 sm:w-35.25 w-32 whitespace-nowrap">
                    <CustomCheckBox
                      label={questions?.smoker?.panMasala}
                      name="medicalDetails.panMasala"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.panMasala}
                    />
                  </div>
                </div>
              )}

              {questions?.smoker?.gutkha && (
                <div
                  className={
                    "flex lg:ml-16.75 xl:mb-0 lg:mb-0 md:mb-10 sm:mb-10 mb-10 " +
                    (jointMarginRequired ? "xl:ml-14.5" : "xl:ml-21.75")
                  }
                >
                  <div className="xl:h-7.25 xl:w-13.25 lg:w-13.25 md:w-35.25 sm:w-35.25 w-32">
                    <CustomCheckBox
                      label="Gutka"
                      name="medicalDetails.gutkha"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues?.medicalDetails?.gutkha}
                    />
                  </div>
                </div>
              )}

              {questions?.smoker?.chewing && (
                <div
                  className={
                    "flex  " +
                    (jointMarginRequired ? "xl:ml-21.75 lg:ml-auto" : "xl:ml-26.25 lg:ml-21.75")
                  }
                >
                  <div className="xl:h-7.25 md:h-6 xl:w-16 lg:w-16 md:w-35.25 sm:w-35.25 w-32">
                    <CustomCheckBox
                      label={questions?.smoker?.chewing}
                      name="medicalDetails.chewing"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.chewing}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className=" flex xl:mt-4 lg:mt-4 md:mt-5 sm:mt-5 mt-4 xl:mr-10 xl:ml-10 lg:ml-10 xl:w-270 lg:w-auto md:w-64 sm:w-53.25  lg:mr-6  md:mr-0 sm:mr-0  mr-0 items-center flex-col xl:flex-row lg:flex-row xl:order-2 lg:order-2 order-last ">
              {questions?.smoker?.amountConsumed && (
                <p className="flex flex-col text-sm xl:h-9.75 xl:w-35.25 lg:w-25 md:w-53.25 sm:w-53.25 w-38 xl:flex lg:flex md:inline-block sm:inline-block xl:mb-0 lg:mb-0 md:mb-4 sm:mb-4 mb-4 xl:ml-0 lg:ml-0 md:ml-4 sm:ml-0 -ml-6 xl:whitespace-nowrap lg:whitespace-nowrap xl:mr-6">
                  {questions?.smoker?.amountConsumed} *
                  <span className=" text-xs text-lightgrey ">({questions?.smoker?.amount})</span>
                </p>
              )}
              {/* ------------------------------------------------------------------ */}

              {questions?.smoker?.cigaratte && (
                <div className=" xl:ml-0 lg:ml-13.75 w-25 h-10  xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 border border-discoBall focus-within:border-hotShot rounded-lg ">
                  <MedicalTextBox
                    smokerTextBox
                    label="Amount"
                    className=""
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.cigaratteAmount}
                    name={"medicalDetails.cigaratteAmount"}
                    error={error?.medicalDetails?.cigaratteAmount}
                    touched={touch?.medicalDetails?.cigaratteAmount}
                    disabledField={isReview || !formValues.medicalDetails.cigaratte}
                  />
                </div>
              )}

              {questions?.smoker?.bidi && (
                <div
                  className={
                    (jointMarginRequired ? "xl:ml-10" : "xl:ml-15.75") +
                    " lg:ml-auto w-25  h-10 rounded-lg xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 bg-white border border-discoBall focus-within:border-hotShot"
                  }
                >
                  <MedicalTextBox
                    smokerTextBox
                    label="Amount"
                    className=""
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.bidiAmount}
                    name={"medicalDetails.bidiAmount"}
                    error={error?.medicalDetails?.bidiAmount}
                    touched={touch?.medicalDetails?.bidiAmount}
                    disabledField={isReview || !formValues.medicalDetails.bidi}
                  />
                </div>
              )}

              {questions?.smoker?.cigar && (
                <div
                  className={
                    (jointMarginRequired ? "xl:ml-10" : "xl:ml-15.75") +
                    "  lg:ml-auto w-25 h-10 rounded-lg xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6  bg-white  border border-discoBall focus-within:border-hotShot"
                  }
                >
                  <MedicalTextBox
                    smokerTextBox
                    label="Amount"
                    className=""
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.cigarAmount}
                    name={"medicalDetails.cigarAmount"}
                    error={error?.medicalDetails?.cigarAmount}
                    touched={touch?.medicalDetails?.cigarAmount}
                    disabledField={isReview || !formValues.medicalDetails.cigar}
                  />
                </div>
              )}

              {questions?.smoker?.panMasala && (
                <div
                  className={
                    (jointMarginRequired ? "xl:ml-10" : "xl:ml-15.75") +
                    "  lg:ml-auto w-25 h-10 rounded-lg xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6  bg-white  border border-discoBall focus-within:border-hotShot"
                  }
                >
                  <MedicalTextBox
                    smokerTextBox
                    label="Amount"
                    className=""
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.panMasalaAmount}
                    name={"medicalDetails.panMasalaAmount"}
                    error={error?.medicalDetails?.panMasalaAmount}
                    touched={touch?.medicalDetails?.panMasalaAmount}
                    disabledField={isReview || !formValues.medicalDetails.panMasala}
                  />
                </div>
              )}

              {questions?.smoker?.gutkha && (
                <div
                  className={
                    (jointMarginRequired ? "xl:ml-10" : "xl:ml-15.75") +
                    " lg:ml-auto w-25 h-10 rounded-lg xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6  bg-white  border border-discoBall focus-within:border-hotShot"
                  }
                >
                  <MedicalTextBox
                    smokerTextBox
                    label="Amount"
                    className=""
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.gutkhaAmount}
                    name={"medicalDetails.gutkhaAmount"}
                    error={error?.medicalDetails?.gutkhaAmount}
                    touched={touch?.medicalDetails?.gutkhaAmount}
                    disabledField={isReview || !formValues.medicalDetails.gutkha}
                  />
                </div>
              )}

              {questions?.smoker?.chewing && (
                <div
                  className={
                    (jointMarginRequired ? "xl:ml-10" : "xl:ml-15.75") +
                    " lg:ml-auto w-25 h-10 rounded-lg  bg-white  border border-discoBall focus-within:border-hotShot"
                  }
                >
                  <MedicalTextBox
                    smokerTextBox
                    label="Amount"
                    className=""
                    onChange={handleChanges}
                    handleBlur={handleBlurs}
                    value={formValues?.medicalDetails?.chewingAmount}
                    name={"medicalDetails.chewingAmount"}
                    error={error?.medicalDetails?.chewingAmount}
                    touched={touch?.medicalDetails?.chewingAmount}
                    disabledField={isReview || !formValues.medicalDetails.chewing}
                  />
                </div>
              )}
            </div>

            <div className="flex xl:mt-5.75 lg:mt-5.75 md:mt-0 sm:mt-0 mt-0 items-center xl:w-auto lg:w-auto md:w-64 sm:w-53.25 flex-col xl:flex-row lg:flex-row xl:order-3 lg:order-3 order-2   ">
              <hr className="xl:ml-51.25 lg:ml-42.25 md:ml-39 xl:w-46.25 lg:w-46.25 " />
              <div className="xl:hidden lg:hidden md:block border-r-1.5 border-blueBerryWhip h-15 mt-24" />
              <p className="w-9 xl:h-5 ml-2.75 mr-2.25 text-xs text-platinumGranite xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-0">
                Sticks
              </p>
              <div className="xl:hidden lg:hidden md:block border-r-1.5 border-blueBerryWhip lg:h-6 h-15 " />
              <hr className="xl:w-46.25 lg:w-46.25  " />

              <hr className="xl:ml-15.75 lg:ml-16.75 md:ml-6 xl:w-46.75 lg:w-46.75 " />
              <div className="xl:hidden lg:hidden md:block border-r-1.5 border-blueBerryWhip h-15 lg:h-6 lg:mt-12 mt-16" />
              <p className="w-13.25 xl:h-5 ml-0.5 mr-0.25 text-xs text-platinumGranite xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-0">
                Pouches
              </p>
              <div className="xl:hidden lg:hidden md:block border-r-1.5 border-blueBerryWhip h-15 " />
              <hr className=" xl:w-46.5 lg:w-46.5 lg:mr-10 md:mr-8" />
            </div>
            {/* ------------------------------------------------ */}
          </div>
          <div className=" flex xl:mt-4 lg:mt-4 md:mt-5 sm:mt-5 mt-4 xl:mr-10 xl:ml-10 lg:ml-10 xl:w-270 lg:w-auto md:w-64 sm:w-53.25  lg:mr-6  md:mr-0 sm:mr-0  mr-0 flex-row lg:flex-row xl:order-2 lg:order-2 order-last ml-4">
            {questions?.smoker?.consumingSince && (
              <p className="flex flex-col text-sm xl:h-9.75 xl:w-35.25 lg:w-25 md:w-53.25 sm:w-53.25 w-38 xl:flex lg:flex md:inline-block sm:inline-block xl:mb-0 lg:mb-0 md:mb-4 sm:mb-4 mb-4 xl:ml-0 lg:ml-0 md:ml-4 sm:ml-10 xl:whitespace-nowrap lg:whitespace-nowrap xl:mr-6">
                {questions?.smoker?.consumingSince} *
                <span className=" text-xs text-lightgrey ">
                  ({questions?.smoker?.consumingFrequency})
                </span>
              </p>
            )}
            {/* ------------------------------------------------------------------ */}

            {questions?.smoker?.consumingSince && (
              <div className=" xl:ml-0 lg:ml-13.75 w-25 h-10  xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 border border-discoBall focus-within:border-hotShot rounded-lg ">
                <MedicalTextBox
                  smokerTextBox
                  label="Enter"
                  className=""
                  onChange={handleChanges}
                  handleBlur={handleBlurs}
                  value={formValues?.medicalDetails?.smokingConsumptionSince || null}
                  name={"medicalDetails.smokingConsumptionSince"}
                  error={error?.medicalDetails?.smokingConsumptionSince}
                  touched={touch?.medicalDetails?.smokingConsumptionSince}
                  disabledField={isReview}
                />
              </div>
            )}
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}
      {questions?.alcohol?.heading && (
        <>
          <div className="flex items-center">
            <p className="  xl:w-208.5 lg:w-208.5 md:w-208.5 sm:w-208.5 w-47 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-49 lg:mr-49 md:mr-49 sm:mr-49 mr-24.25 xl:whitespace-nowrap lg:whitespace-nowrap ">
              {questions?.alcohol?.heading}
            </p>

            <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails?.alcohol}
                fieldName="alcohol"
                setFieldValue={!isReview ? setFieldValue : false}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-8 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}
      <div className="xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 whitespace-nowrap text-hotShot text-xs">
        {alcoholError && <p>Atleast one value is required</p>}
      </div>
      {formValues.medicalDetails.alcohol && (
        <>
          <div className="flex xl:flex-col lg:flex-col md:flex-row sm:flex-col flex-col   xl:ml-0 lg:ml-0 md:ml-10  xl:mr-0 lg:mr-0 md:mr-10   ">
            <div className="flex xl:h-7.25 w-60  mb-0 xl:whitespace-nowrap lg:whitespace-nowrap  lg:mt-8.75 md:mt-4 sm:mt-4 mt-4 xl:w-auto  md:ml-0 sm:ml-10 ml-4 lg:w-auto md:w-64 sm:w-53.25 xl:ml-10 lg:ml-10    xl:mr-13.25 lg:mr-10  flex-col xl:flex-row lg:flex-row order-first ">
              {questions?.alcohol?.type && (
                <p className="flex xl:h-7.25 w-60 xl:mb-0 lg:mb-0 md:mb-6 sm:mb-7 ml-0 mb-4 xl:whitespace-nowrap lg:whitespace-nowrap ">
                  {questions?.alcohol?.type}*
                </p>
              )}
              {questions?.alcohol?.beer && (
                <div
                  className={
                    "flex lg:ml-9.75  xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 " +
                    (jointMarginRequired ? "xl:ml-11.75" : "xl:ml-11.75")
                  }
                >
                  <div className="xl:h-7.25 xl:w-16.5 lg:w-16.5 md:w-35.25 sm:w-35.25 w-32 whitespace-nowrap">
                    <CustomCheckBox
                      label={questions?.alcohol?.beer}
                      name="medicalDetails.beer"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.beer}
                    />
                  </div>
                </div>
              )}
              {questions?.alcohol?.wine && (
                <div
                  className={
                    "flex lg:ml-18.5 xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 " +
                    (jointMarginRequired ? "xl:ml-18.5" : "xl:ml-25.5")
                  }
                >
                  <div className="xl:h-7.25 xl:w-7 lg:w-7 md:w-35.25 sm:w-35.25 w-32">
                    <CustomCheckBox
                      label={questions?.alcohol?.wine}
                      name="medicalDetails.wine"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.wine}
                    />
                  </div>
                </div>
              )}
              {questions?.alcohol?.liquor && (
                <div
                  className={
                    "flex lg:ml-28.5  xl:mb-0 lg:mb-0 md:mb-11 sm:mb-9 mb-9 " +
                    (jointMarginRequired ? "xl:ml-28.5" : "xl:ml-36.25 ")
                  }
                >
                  <div className="xl:h-7.25 xl:w-16.5 lg:w-16.5 md:w-35.25 sm:w-35.25 w-32 whitespace-nowrap">
                    <CustomCheckBox
                      label={questions?.alcohol?.liquor}
                      name="medicalDetails.liquor"
                      handleBlur={handleBlurs}
                      setFieldValue={setFieldValue}
                      isReview={isReview}
                      checked={formValues.medicalDetails.liquor}
                    />
                  </div>
                </div>
              )}
            </div>
            {/* <div className="grid grid-colxl:h-5 text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-49 lg:mr-49 md:mr-49 sm:mr-49 mr-24.25 text-red-500 text-xs mt-2 xl:h-7.25 w-60 xl:mb-0 lg:mb-0 md:mb-6 sm:mb-4 mb-4 xl:whitespace-nowrap lg:whitespace-nowrap ">
            {frequencyError && <p className="">Atleast one value is required</p>}{" "}
          </div> */}

            <div className="flex xl:h-36 lg:h-36  h-auto  xl:mt-8.75 lg:mt-8.75 md:mt-4 sm:mt-4 mt-4 xl:w-auto lg:w-auto md:w-64 sm:w-53.25 w-43.25  xl:ml-10 lg:ml-10 md:ml-0 sm:ml-10 ml-4  xl:mr-13.25 lg:mr-10 flex-col xl:flex-row lg:flex-row order-first  ">
              <p className="xl:h-7.25 w-60 xl:mb-0 lg:mb-0 md:mb-6 sm:mb-4 mb-4 xl:whitespace-nowrap lg:whitespace-nowrap ">
                Frequency of consumption* <br />
                <div className="whitespace-nowrap text-hotShot text-xs">
                  {frequencyError && <p className="">Atleast one value is required</p>}
                </div>
              </p>
              {/* <br></br> */}

              {/* <div className="xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 whitespace-nowrap text-hotShot text-xs"></div> */}
              <div className="grid grid-col">
                {questions?.alcohol?.frequency?.lessThanOnce && (
                  <div
                    className={
                      "flex lg:ml-9.75  xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 " +
                      (jointMarginRequired ? "xl:ml-11.75" : "xl:ml-11.75")
                    }
                  >
                    <div className="xl:h-7.25 xl:w-16.5 lg:w-16.5 md:w-35.25 sm:w-35.25 w-32 whitespace-nowrap">
                      <CustomCheckBox
                        label={questions?.alcohol?.frequency?.lessThanOnce}
                        name="medicalDetails.lessThanOnce"
                        handleBlur={handleBlurs}
                        setFieldValue={setFieldValue}
                        isReview={isReview}
                        checked={formValues.medicalDetails.lessThanOnce}
                      />
                      {/* <CustomRadioButton
                    //   requiredStar
                    name="covidTest.covidQuarantine"
                    label=""
                    options={[
                      "Less than once a week",
                      "More than once a week",
                      "Once a week",
                      "daily"
                    ]}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouch}
                    error={error?.medicalDetails?.once}
                    touched={error?.medicalDetails?.once}
                    // defaultValue={formik.values.covidTest?.covidQuarantine}
                  /> */}
                    </div>
                  </div>
                )}

                {questions?.alcohol?.frequency?.moreThanOnce && (
                  <div
                    className={
                      "flex lg:ml-9.75  xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 " +
                      (jointMarginRequired ? "xl:ml-11.75" : "xl:ml-11.75")
                    }
                  >
                    <div className="xl:h-7.25 xl:w-16.5 lg:w-16.5 md:w-35.25 sm:w-35.25 w-32 whitespace-nowrap">
                      <CustomCheckBox
                        label={questions?.alcohol?.frequency?.moreThanOnce}
                        name="medicalDetails.moreThanOnce"
                        handleBlur={handleBlurs}
                        setFieldValue={setFieldValue}
                        isReview={isReview}
                        checked={formValues.medicalDetails.moreThanOnce}
                      />
                    </div>
                  </div>
                )}

                {questions?.alcohol?.frequency?.once && (
                  <div
                    className={
                      "flex lg:ml-9.75  xl:mb-0 lg:mb-0 md:mb-6 sm:mb-6 mb-6 " +
                      (jointMarginRequired ? "xl:ml-11.75" : "xl:ml-11.75")
                    }
                  >
                    <div className="xl:h-7.25 xl:w-16.5 lg:w-16.5 md:w-35.25 sm:w-35.25 w-32 whitespace-nowrap">
                      <CustomCheckBox
                        label={questions?.alcohol?.frequency?.once}
                        name="medicalDetails.once"
                        handleBlur={handleBlurs}
                        setFieldValue={setFieldValue}
                        isReview={isReview}
                        checked={formValues.medicalDetails.once}
                      />
                    </div>
                  </div>
                )}
                {questions?.alcohol?.frequency?.daily && (
                  <div
                    className={
                      "flex lg:ml-9.75  xl:mb-0 lg:mb-0 md:mb-6 sm:mb-0 mb-0 " +
                      (jointMarginRequired ? "xl:ml-11.75" : "xl:ml-11.75")
                    }
                  >
                    <div className="xl:h-7.25 xl:w-16.5 lg:w-16.5 md:w-35.25 sm:w-35.25 w-32 whitespace-nowrap">
                      <CustomCheckBox
                        label={questions?.alcohol?.frequency?.daily}
                        name="medicalDetails.daily"
                        handleBlur={handleBlurs}
                        setFieldValue={setFieldValue}
                        isReview={isReview}
                        checked={formValues.medicalDetails.daily}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className=" flex xl:mt-4 lg:mt-4 md:mt-5 sm:mt-10 mt-10 xl:mr-10 xl:ml-10 lg:ml-10 md:ml-0 sm:ml-10 ml-4 xl:w-270 lg:w-auto md:w-64 w-auto lg:mr-6  md:mr-0 sm:mr-0  mr-0 xl:items-center lg:items-center md:items-center items-start flex-col xl:flex-row lg:flex-row xl:order-2 lg:order-2 order-last ">
              {questions?.alcohol?.alcoholAmount && (
                <p className="flex flex-col text-sm xl:h-9.75 xl:w-60 lg:w-40 md:w-53.25 sm:w-53.25 w-38 xl:flex lg:flex md:inline-block sm:inline-block xl:mb-0 lg:mb-0 md:mb-4 sm:mb-4 mb-4 xl:ml-0 lg:ml-0 md:ml-0 sm:ml-0 ml-0 xl:whitespace-nowrap lg:whitespace-nowrap xl:mr-6">
                  {questions?.alcohol?.alcoholAmount}*
                  <span className=" text-xs text-lightgrey ">({questions?.alcohol?.amount})</span>
                </p>
              )}
              {/* ------------------------------------------------------------------ */}

              {questions?.alcohol?.type && (
                <MedicalTextBox
                  label="Amount"
                  globalClassName="xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 rounded-lg "
                  className=" xl:w-auto lg:w-auto md:w-auto w-full"
                  onChange={handleChanges}
                  handleBlur={handleBlurs}
                  value={formValues?.medicalDetails?.alcoholAmount}
                  name={"medicalDetails.alcoholAmount"}
                  error={error?.medicalDetails?.alcoholAmount}
                  touched={touch?.medicalDetails?.alcoholAmount}
                  disabledField={
                    isReview ||
                    !(
                      (formValues.medicalDetails.beer ||
                        formValues.medicalDetails.wine ||
                        formValues.medicalDetails.liquor) &&
                      (formValues.medicalDetails.lessThanOnce ||
                        formValues.medicalDetails.moreThanOnce ||
                        formValues.medicalDetails.once ||
                        formValues.medicalDetails.daily)
                    )
                  }
                />
              )}

              {questions?.alcohol?.amountConsumedNote && (
                <span className="ml-2">
                  <p className="mt-8 xl:whitespace-nowrap lg:whitespace-nowrap md:whitespace-normal sm:whitespace-nowrap text-xs">
                    {questions?.alcohol?.amountConsumedNote}
                  </p>
                </span>
              )}
            </div>

            {/* ------------------------------------------------ */}
            <div className=" flex xl:mt-4 lg:mt-4 md:mt-5 sm:mt-10 mt-10 xl:mr-10 xl:ml-10 lg:ml-10 md:ml-0 sm:ml-10 ml-4 xl:w-270 lg:w-auto md:w-64 w-auto lg:mr-6  md:mr-0 sm:mr-0  mr-0 xl:items-center lg:items-center md:items-center items-start flex-col xl:flex-row lg:flex-row xl:order-2 lg:order-2 order-last ">
              {questions?.alcohol?.consumingSince && (
                <p className="flex flex-col text-sm xl:h-9.75 xl:w-60 lg:w-40 md:w-53.25 sm:w-53.25 w-38 xl:flex lg:flex md:inline-block sm:inline-block xl:mb-0 lg:mb-0 md:mb-4 sm:mb-4 mb-4 xl:ml-0 lg:ml-0 md:ml-0 sm:ml-0 ml-0 xl:whitespace-nowrap lg:whitespace-nowrap xl:mr-6">
                  {questions?.alcohol?.consumingSince}*
                  <span className=" text-xs text-lightgrey ">
                    ({questions?.alcohol?.consumingFrequency})
                  </span>
                </p>
              )}

              {questions?.alcohol?.consumingSince && (
                <MedicalTextBox
                  label="Enter"
                  globalClassName="xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 rounded-lg "
                  className=" xl:w-auto lg:w-auto md:w-auto w-full"
                  onChange={handleChanges}
                  handleBlur={handleBlurs}
                  value={formValues?.medicalDetails?.alcoholConsumptionSince || null}
                  name={"medicalDetails.alcoholConsumptionSince"}
                  error={error?.medicalDetails?.alcoholConsumptionSince}
                  touched={touch?.medicalDetails?.alcoholConsumptionSince}
                  disabledField={isReview}
                />
              )}
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-8 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}
      {questions?.drugs && (
        <>
          <div className="flex items-center">
            <p className="xl:w-208.5 lg:w-208.5 md:w-208.5 sm:w-208.5 w-63.75 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-49 lg:mr-49 md:mr-49 sm:mr-49 mr-7.25 ">
              {questions?.drugs}
            </p>

            <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.drugs}
                fieldName="drugs"
                setFieldValue={setFieldValue}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
        </>
      )}
      {questions?.disability && (
        <>
          <div className="flex items-center">
            <p className="xl:w-208.5 lg:w-208.5 md:w-208.5 sm:w-208.5 w-63.75 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-49 lg:mr-49 md:mr-49 sm:mr-49  mr-7.25 xl:whitespace-nowrap lg:whitespace-nowrap  ">
              {questions?.disability}
            </p>

            <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
              <CustomizedSwitches
                isEnabled={!isReview ? true : false}
                toggleState={formValues.medicalDetails.disability}
                fieldName="disability"
                setFieldValue={setFieldValue}
                fieldObj={"medicalDetails"}
              />
            </div>
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6 opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
        </>
      )}
      {gender == "Female" && (
        <>
          <div>
            {questions?.pregnancy?.heading && (
              <div className="flex mb-6">
                <p className="xl:h-5 xl:w-152 lg:w-152 md:w-208.5 sm:w-208.5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 xl:whitespace-nowrap lg:whitespace-nowrap">
                  {questions?.pregnancy?.heading}
                </p>
              </div>
            )}
            {questions?.pregnancy?.gyneComplications && (
              <div className="flex">
                <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-24 lg:h-auto md:h-auto sm:h-auto h-75 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
                  {questions?.pregnancy?.gyneComplications}
                </p>

                <div className=" xl:mr-10 mt-1  lg:mr-10 md:mr-10 sm:mr-10 mr-4 ">
                  <CustomizedSwitches
                    isEnabled={!isReview ? true : false}
                    toggleState={formValues.medicalDetails.gyneComplications}
                    fieldName="gyneComplications"
                    setFieldValue={setFieldValue}
                    fieldObj={"medicalDetails"}
                  />
                </div>
              </div>
            )}
            {questions?.pregnancy?.pregnant && (
              <div className="flex mt-7 ">
                <p className="  xl:w-212.75  lg:w-212.75 md:w-212.75 sm:w-212.75 flex text-justify xl:ml-12.5 lg:ml-12.5 md:ml-12.5 sm:ml-12.5 ml-4 xl:mr-42.25 lg:mr-42.25 md:mr-42.25 sm:mr-42.25 mr-18 xl:whitespace-nowrap lg:whitespace-nowrap ">
                  Are you pregnant at present ?
                </p>

                <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 ">
                  <CustomizedSwitches
                    isEnabled={!isReview ? true : false}
                    toggleState={formValues.medicalDetails.pregnant}
                    fieldName="pregnant"
                    setFieldValue={setFieldValue}
                    fieldObj={"medicalDetails"}
                  />
                </div>
              </div>
            )}
            {formValues?.medicalDetails?.pregnant && (
              <div className="xl:w-60 lg:w-60 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 mt-4 ">
                <MedicalTextBox
                  requiredStar
                  label="Duration in weeks"
                  className=""
                  onChange={handleChanges}
                  handleBlur={handleBlurs}
                  value={formValues?.medicalDetails?.pregnancyDuration}
                  name={"medicalDetails.pregnancyDuration"}
                  error={error?.medicalDetails?.pregnancyDuration}
                  touched={touch?.medicalDetails?.pregnancyDuration}
                  disabledField={isReview}
                />
              </div>
            )}
          </div>
          <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6 opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
        </>
      )}
      {questions?.remarks && (
        <>
          <div className="flex">
            <p className="w-219.25 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
              {questions?.remarks}
            </p>
          </div>
          <div className=" xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 mt-4 ">
            <MedicalTextBox
              label="Write here..."
              className=""
              onChange={handleChanges}
              handleBlur={handleBlurs}
              value={formValues?.medicalDetails?.remarks}
              name={"medicalDetails.remarks"}
              error={error?.medicalDetails?.remarks}
              touched={touch?.medicalDetails?.remarks}
              disabledField={isReview}
            />
          </div>
        </>
      )}
    </div>
  );
}

MedicalAndLifestyle.defaultProps = {
  formValues: {},
  setFieldValue: "",
  setFieldTouch: "",
  handleBlurs: "",
  handleChanges: "",
  error: "",
  touch: "",
  jointMarginRequired: false,
  fieldObj: "",
  gender: "",
  width: "89.5",
  smokerError: false,
  alcoholError: false,
  frequencyError: false
};

export default MedicalAndLifestyle;
